import React, { useState, useContext, useEffect, useRef } from 'react';

/**
 * DWT dependencies
 */

import { BooksContext } from '../Books/BooksContext';
import { AudioContext } from '../AudioPlayer/AudioContext';
import { ModalContext } from '../Modal/ModalContext';

/**
 * DWT hooks
 */

import useModal from '../../hooks/useModal';

/**
 * DWT components
 */

import LoadMoreButton from '../LoadMoreButton';
import Modal from '../Modal/Modal';
import Grid from '../Grid';

const BookTab = ({ prhData, recordCount, searchTerm, loadMore, loading }) => {
  const c = useContext( BooksContext );
  const [ context, setContext ] = useState( c );
  const [ currentlyPlayingIsbn, setCurrentlyPlayingIsbn ] = useState( null );
  const allowedMetadataFields = JSON.stringify( window.DP.metadata_fields );
  const modalRef = useRef( null );

  const {
    modalClass,
    modalData,
    modalType,
    onClickOpenModal,
    onClickCloseModal
  } = useModal( prhData, modalRef, context );

  const error = null;

  useEffect( () => {
    setContext({
      featureBy: 'books',
      allowedMetadataFields,
      entry: 'automatic'
    });
  }, [] );

  return (
    <ModalContext.Provider value={{ onClickOpenModal }}>
      <BooksContext.Provider
        value={{
          featureBy: 'books',
          allowedMetadataFields,
          entry: 'automatic'
        }}
      >
        <AudioContext.Provider
          value={{ currentlyPlayingIsbn, setCurrentlyPlayingIsbn }}
        >
          <div className="m-auto my-32 min-h-[1000px] max-w-lg">
            {recordCount > 0 && (
              <h1>
                {recordCount} results for &ldquo;{searchTerm}
                                &rdquo;
              </h1>
            )}

            <div className="list-wrapper container col-span-full my-32 grid min-h-[1000px] grid-cols-2 gap-20 md:grid-cols-3 lg:grid-cols-4">
              <Grid
                context={context}
                data={prhData}
                showMetadata
                error={error}
                loading={loading}
              />
            </div>

            {recordCount > prhData.length && (
              <LoadMoreButton
                makeRequest={loadMore}
                loading={loading}
              />
            )}

            <Modal
              context={context}
              modalData={modalData}
              modalClass={modalClass}
              onClose={onClickCloseModal}
              modalType={modalType}
              ref={modalRef}
            />
          </div>
        </AudioContext.Provider>
      </BooksContext.Provider>
    </ModalContext.Provider>
  );
};

export default BookTab;
